import React from 'react';
import { Layout, Menu, Avatar, Typography, Button, Space } from 'antd';
import { Link, useNavigate } from 'react-router';
import { UserOutlined, DashboardOutlined, ProfileOutlined, LogoutOutlined, CalendarOutlined } from '@ant-design/icons';
import { User } from '../api/model';
import { userApi } from '../api/user';
import { useCurrentUser } from '../util/hooks';

const { Sider, Header, Content } = Layout;
const { Title } = Typography;

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const user: User = useCurrentUser();

  const handleLogout = async () => {
    try {
      await userApi.logout();
      localStorage.removeItem('user');
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={256} theme="light" style={{ boxShadow: '2px 0 8px rgba(0, 0, 0, 0.06)' }}>
        <div style={{ padding: '24px', textAlign: 'center', borderBottom: '1px solid #f0f0f0' }}>
          <Title level={4} style={{ margin: 0 }}>医生管理系统</Title>
        </div>
        <div style={{ padding: '24px' }}>
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <Avatar size={64} icon={<UserOutlined />} style={{ marginBottom: '8px' }} />
              <div>{user.name || '未登录'}</div>
              <div style={{ fontSize: '12px', color: '#999' }}>{user.doctor?.title || '医生'}</div>
            </div>

            <Menu mode="inline" selectedKeys={[window.location.pathname]}>
          <Menu.Item key="/dashboard" icon={<DashboardOutlined />}>
            <Link to="/dashboard">仪表盘</Link>
          </Menu.Item>
          <Menu.Item key="/appointments" icon={<CalendarOutlined />}>
            <Link to="/appointments">预约管理</Link>
          </Menu.Item>
          <Menu.Item key="/patients" icon={<UserOutlined />}>
            <Link to="/patients">患者列表</Link>
          </Menu.Item>
          <Menu.Item key="/schedules" icon={<CalendarOutlined />}>
            <Link to="/schedules">日程管理</Link>
          </Menu.Item>
          <Menu.Item key="/schedule-templates" icon={<CalendarOutlined />}>
            <Link to="/schedule-templates">排班模板</Link>
          </Menu.Item>
          <Menu.Item key="/schedule-locations" icon={<CalendarOutlined />}>
            <Link to="/schedule-locations">地点管理</Link>
          </Menu.Item>
          <Menu.Item key="/custom-enum-management" icon={<UserOutlined />}>
            <Link to="/custom-enum-management">参数管理</Link>
          </Menu.Item>
          <Menu.Item key="/profile" icon={<ProfileOutlined />}>
            <Link to="/profile">个人资料</Link>
          </Menu.Item>
        </Menu>

            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={handleLogout}
              style={{ marginTop: '24px', justifyContent: 'flex-start' }}
            >
              退出登录
            </Button>
          </Space>
        </div>
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', borderBottom: '1px solid #f0f0f0' }}>
          <Title level={5} style={{ margin: '16px 0' }}>医生管理系统</Title>
        </Header>
        <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;